import React, { useState } from "react";
import Signin from "../../Auth/Signin";
import UserVerifyOtp from "../../Auth/UserVerifyOtp";
import useAuth from "../../../hooks/useAuth";
import Logo from "../../../assets/images/image_2023.png"
export default function Login() {
  const [page, setPage] = useState(0);
  const {auth}=useAuth();
  return (
      <>
        <div  className="pupLogin">
          <div className="loginBlock">
            <div className="logo" onClick={(e)=> e.preventDefault()}>
              <a href="" >
                <img
                    src={Logo}
                    alt="P.UP"
                />
              </a>
            </div>
            <div className="loginContent">
              {page === 0 ? (
                  <Signin setPage={setPage} />
              ) : (
                  <UserVerifyOtp setPage={setPage} />
              )}
            </div>
          </div>
        </div>
      </>
  );
}
